import useCustomEventListener from "./useCustomEventListener";

const TRIGGER_ADDRESS_POPUP = "trigger-address-popup";

const useTriggerAddressPopupListener = (callback) => {
    useCustomEventListener(TRIGGER_ADDRESS_POPUP, callback);
};

export default useTriggerAddressPopupListener;
